// extracted by mini-css-extract-plugin
export default {"formContainer":"NewBookingWrap_formContainer__Ex0QZ","mainContainer":"NewBookingWrap_mainContainer__3AC7U","btnSave":"NewBookingWrap_btnSave__zFLIy"};